import React from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, updateItemmaster } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import { showSuccessSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
  "@media (min-width:600px)": {
    width: "auto",
  },
  width: "90%",
};

const ListingActive = ({ open, text, setFn, setOpen, editData, action }) => {
  const { theme } = useThemes();

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
    if (setFn) {
      setFn();
    }
  };
  console.log(open, "open");
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{zIndex:9999}}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>

         <Box sx={{display:"flex",justifyContent:"flex-end",padding:"10px",backgroundColor:theme.palette.primary.main,borderTopLeftRadius:"4px",borderTopRightRadius:"4px"}}>
            <CloseIcon fontSize="10px" sx={{color:"white",cursor:"pointer"}} onClick={handleClose}/>
        </Box>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? ""
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to Make the {text}{" "}
            {editData?.serialisactive == 1 ? "Inactive" : "Active"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <Button
            color="info"
            onClick={() => {
              action();
              handleClose();
            }}
            variant="contained"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            Yes
          </Button>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default ListingActive;
